// Categories/subcategories are admin-managed now (see Manage Categories) and
// fetched from the API — no longer hardcoded here.
export const PAYMENT_METHODS = ["Cash", "UPI", "Card", "Bank Transfer"];
